import { Component } from '@angular/core';
import { IAgentFeature } from '../shared/page-agent-features/page-agent-features.component';
import { IBreadcrumbsItem } from '../../module/shared/components/breadcrumbs/breadcrumbs.component';
import { AppModule } from '../../../app.module';
import { PageOffersComponent } from '../shared/page-offers/page-offers.component';
import { SharedModule } from '../../module/shared/shared.module';

@Component({
  selector: 'app-security-deal',
  standalone: true,
  templateUrl: './security-deal.component.html',
  imports: [AppModule, PageOffersComponent, SharedModule],
  styleUrl: './security-deal.component.scss',
})
export class SecurityDealComponent {
  breadcrumbs: IBreadcrumbsItem[] = [
    {
      title: 'Главная',
      href: '/',
    },
    {
      title: 'Сервисы',
      href: '/services/',
    },
    {
      title: 'Гарантия безопасности сделки',
      href: '',
    },
  ];

  features: IAgentFeature[] = [
    {
      icon: 'assets/images/selection-agents/feature-1.svg',
      title: 'Проверка объекта и продавца',
      text: 'Убедимся, что документы в порядке, а собственник имеет право на продажу',
    },
    {
      icon: 'assets/images/selection-agents/feature-2.svg',
      title: 'Безопасные расчёты',
      text: 'Обеспечиваем проведение безопасных расчетов между сторонами сделки',
    },
    {
      icon: 'assets/images/selection-agents/feature-3.svg',
      title: 'Проведёте сделку безопасно',
      text: 'Берём на себя юридическое сопровождение и обеспечиваем поддержку на всех этапах сделки',
    },
  ];

  faqs = [
    {
      question: 'Для кого этот сервис?',
      answer: '',
      open: false,
    },
    {
      question: 'Почему важно проверять вторичную недвижимость перед покупкой?',
      answer: `Проверка вторичного жилья перед покупкой — это надежный способ защитить ваши интересы. Вы сможете убедиться в корректности документов, отсутствии обременений на объекте и законности владения продавца. Такая проверка минимизирует риски мошенничества и будущих судебных споров после сделки. Это не формальная процедура, а гарантия вашего спокойствия.`,
      open: false,
    },
    {
      question: 'Какие документы нужно предоставить?',
      answer: '',
      open: false,
    },
  ];

  security = [
    {
      icon: 'assets/images/svg_new/bankruptcy.svg',
      title: 'Банкротство продавца',
    },
    {
      icon: 'assets/images/svg_new/owners.svg',
      title: 'Неочевидные владельцы',
    },
    {
      icon: 'assets/images/svg_new/claims.svg',
      title: 'Претензии бывших собственников',
    },
  ];

  feature = [
    {
      title: 'Гарантия безопасности',
      text: 'Проведем тщательную проверку недвижимости и обеспечим вам страховку от рисков после завершения сделки',
      icon: 'assets/images/svg_new/mortgage_key.svg',
    },
    {
      title: 'Юридическое сопровождение',
      text: 'Окажем вам помощь в подготовке к судебному заседанию и обеспечим защиту права собственности в случае возникновения споров',
      icon: 'assets/images/svg_new/streamline-color_notification-message-alert-flat.svg',
    },
    {
      title: 'Представление интересов в суде',
      text: 'Юристы бесплатно защищают ваши интересы в суде в случае гарантийного инцидента, возникшего после заключения сделки',
      icon: 'assets/images/svg_new/fluent-color_lock-shield.svg',
    },
  ];
}
